export const TOKEN = 'TOKEN'
export const REMEMBER_ME = 'REMEMBER_ME'
